import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const PrivacyPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const toggle = (index: any) => setActiveIndex(index === activeIndex ? -1 : index);

  const AccordionItem = ({ index, title, children }: { index: any; title: any; children: any }) => {
    const isActive = activeIndex === index;
    return (
      <div className="border-b">
        <button
          type="button"
          className="flex w-full items-center gap-2 py-3 text-left font-medium"
          onClick={() => toggle(index)}
        >
          <ChevronDown className={`h-4 w-4 transition-transform ${isActive ? "rotate-180" : ""}`} />
          {title}
        </button>
        {isActive && <div className="pb-3 pl-6">{children}</div>}
      </div>
    );
  };

  return (
    <>
      <strong>Support Information</strong>
      <p>
        If you've got any problems using this app, or any feedback of any sort, then please drop me
        a note. I can be reached at{" "}
        <a href="mailto:kilnhelper@ourhouse.org.uk">kilnhelper@ourhouse.org.uk</a>. Thank you!
      </p>
      <p>In addition, here are some FAQ type questions below:</p>
      <div>
        <AccordionItem index={1} title="Why do I need to create a user to use this app?">
          Part of the requirement for the app is to store your project information, and to allow it
          to be accessed from multiple devices. To do this, we store data on a cloud service, and to
          ensure that only you can access it, we make you log in to retrieve it. If you're an apple
          user, and you're concerned about the privacy implications, etc, then feel free to use the
          'Sign in with Apple' options, and select 'Hide My Email'. If you do this, then I'll know
          nothing more about you than a randomly generated email address.
        </AccordionItem>
        <AccordionItem index={2} title="Where is my data stored?">
          KilnHelper uses Firebase to provide it's back-end platform. Firebase is now owned by
          Google, and their systems are operated inside Google Cloud Platform datacentres. The
          actual data for your projects, kilns, firings, etc, are stored in a Firebase realtime
          database, and your photos are stored in a GCP cloud storage bucket. Both of these
          resources are located within the US.
        </AccordionItem>
        <AccordionItem index={3} title="How do I get rid of all of my data?">
          Just drop me a note to 'kilnhelper@ourhouse.org.uk', and I'll make sure it's all got shot
          of. Sorry things didn't work out ;)
        </AccordionItem>
      </div>
    </>
  );
};

export default PrivacyPage;
